import { render, staticRenderFns } from "./sensitivewordsinfoadd.vue?vue&type=template&id=0897e904&scoped=true"
import script from "./sensitivewordsinfoadd.vue?vue&type=script&lang=js"
export * from "./sensitivewordsinfoadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0897e904",
  null
  
)

export default component.exports